import { render } from "./keyFeatures.vue?vue&type=template&id=65d6804a&scoped=true"
import script from "./keyFeatures.vue?vue&type=script&lang=js"
export * from "./keyFeatures.vue?vue&type=script&lang=js"

import "./keyFeatures.vue?vue&type=style&index=0&id=65d6804a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d6804a"]])

export default __exports__